module.exports = __webpack_public_path__ + "img/Capture8.16b1e01c.jpg";